module.exports = __webpack_public_path__ + "img/home-banner.42717666.png";